var ChartsPlugin = require('utils/charts/charts_plugin');

var Misc = require('utils/misc');

var ChartsZoomEnhance = ChartsPlugin.extend({
    ui: {
        btnResetZoom: '.js-chart-reset-zoom',
    },
    lastEnhanceReq: undefined,
    lastViewChange: {
        window: [undefined, undefined],
        time: undefined,
        interval: 400,
        checked: false,
    },
    waitingForTouchMove: false,
    initPlugin: function () {
        var self = this;

        this.isEnhancing = false;

        this.chartView.on('charts:draw:after', function () {
            self.foreachCharts(function (key, value) {
                this.onDrawCallback(value, false);
            });
        });

        $(this.ui.btnResetZoom).on('click', function () {
            var currentDateWindow = self.getDateWindow();
            self.chartView.chartAxesSettings = {};
            self.chartView.updateOptions(currentDateWindow[0], currentDateWindow[1], true, true, undefined, true);
        });
    },

    onDrawCallback: function (g, is_initial) {
        var self = this;
        if (this.isEnhancing) return;
        this.checkViewChange();
    },

    checkViewChange: function () {
        var self = this;
        var cw = this.getDateWindow();

        if (this.lastViewChange.window[0] == cw[0] && this.lastViewChange.window[1] == cw[1]) {
            if (this.lastViewChange.checked) return;

            var timeDiff = new Date().getTime() - self.lastViewChange.time.getTime();
            if (timeDiff <= self.lastViewChange.interval) {
                return;
            } else {
                this.lastViewChange.time = new Date();
                this.lastViewChange.checked = true;
                this.checkEnhance();
            }
        } else {
            this.lastViewChange.window = [cw[0], cw[1]];
            this.lastViewChange.time = new Date();
            this.lastViewChange.checked = false;
            setTimeout(function () {
                self.checkViewChange();
            }, self.lastViewChange.interval + 1);
        }
    },

    checkEnhance: function () {
        // get the current biggest difference between visible points
        var maxDifferenceSecs = this.getMaxDifference();
        if (maxDifferenceSecs === undefined) {
            this.isEnhancing = false;
            return;
        }
        // calculate optimal difference
        var optDifferenceSecs = this.getOptimalDifference();
        if (optDifferenceSecs == undefined) {
            this.isEnhancing = false;
            return;
        }
        // when neccessary, do the enhancement
        if (maxDifferenceSecs != optDifferenceSecs) {
            var request = this.getOptimalRequest(optDifferenceSecs);
            this.requestData(request);
        } else {
            this.isEnhancing = false;
        }
    },

    getMaxDifference: function () {
        var maxDifference = undefined;

        this.foreachCharts(function (id, g) {
            var dateWindow = this.getDateWindow(g);
            var data = g.file_;
            var winMin = Math.min(dateWindow[0], dateWindow[1]);
            var winMax = Math.max(dateWindow[0], dateWindow[1]);

            var idx = 1;
            while (idx < data.length) {
                if (data[idx][0] >= winMin && data[idx][0] < winMax) {
                    var diff = data[idx][0] - data[idx - 1][0];
                    if (maxDifference === undefined || maxDifference < diff) maxDifference = diff;
                }
                idx++;
            }
        });

        return Math.ceil(maxDifference / 1000);
    },

    getOptimalDifference: function () {
        var currentDateWindow = this.getDateWindow();
        return Math.ceil(this.data.getResolution(currentDateWindow[0] / 1000, currentDateWindow[1] / 1000));
    },

    getOptimalRequest: function (resolution) {
        var currentDateWindow = this.getDateWindow();

        var from = Math.floor(currentDateWindow[0] / 1000);
        var till = Math.ceil(currentDateWindow[1] / 1000);

        var reqData = this.data.getRequestData(
            from,
            (this.data && this.data.request && this.data.request.from) || from,
            till,
            resolution,
            this.data.getSelectedFields()
        );
        return reqData;
    },

    requestData: function (request) {
        var self = this;
        var r = JSON.stringify(request);
        // is the URL same as the previous one? then the enhancement hasn't worked, no need to do it again
        if (r == this.lastEnhanceReq) {
            this.isEnhancing = false;
            return;
        }

        this.lastEnhanceReq = r;

        this.data.requestData({
            from: request.from * 1000,
            origFrom: request.origFrom ? request.origFrom * 1000 : undefined,
            data: r,
            error: function (err) {
                self.isEnhancing = false;
            },
            success: function (values) {
                if (self.hasData(values)) {
                    self.integrate(values, request);
                    self.redrawChart();
                    self.isEnhancing = false;
                    // was there a change meanwhile? let's try again
                    self.checkEnhance();
                }
                self.isEnhancing = false;
            },
        });
    },

    hasData: function (data) {
        return data && data.values && data.values.length > 0;
    },

    integrate: function (data, request) {
        var newData = {
            values: [],
            interpolated: [],
        };
        var minDataTime = Math.max(data.values[0][0], request.origFrom || 0);
        var maxDataTime = data.values[data.values.length - 1][0];
        var oldDataFrom = 0;

        // old data: before
        for (var idx = 0; idx < this.data.basisData.length; idx++) {
            var ts = this.data.basisData[idx][0];
            if (ts < minDataTime) {
                newData.values.push(this.data.basisData[idx]);
                newData.interpolated.push(this.data.basisDataInterpolated[idx]);
                oldDataFrom = idx;
            }
        }

        // new data
        for (var idx = 0; idx < data.values.length; idx++) {
            newData.values.push(data.values[idx]);
            newData.interpolated.push(data.interpolated[idx]);
        }

        // old data: after
        for (var idx = oldDataFrom; idx < this.data.basisData.length; idx++) {
            if (this.data.basisData[idx][0] > maxDataTime) {
                newData.values.push(this.data.basisData[idx]);
                newData.interpolated.push(this.data.basisDataInterpolated[idx]);
            }
        }

        this.data.rawData = newData.values;
        this.data.rawDataInterpolated = newData.interpolated;
    },

    redrawChart: function () {
        var currentDateWindow = this.getDateWindow();

        var currentValueRanges = {};
        this.foreachCharts(function (k, v) {
            currentValueRanges[k] = this.getValueMaxWindow(v);
        });

        this.chartView.updateOptions(currentDateWindow[0], currentDateWindow[1], true, true);

        this.foreachCharts(function (name, g) {
            // check if the values fit to the value window
            var currentMinMax = currentValueRanges[name];

            var minmax = [];
            _.each(g.user_attrs_.seriesInfo, function (s, i) {
                var line = Misc.selectWhere(
                    g.file_,
                    function (a) {
                        return a[i + 1] !== null && a[i + 1] !== undefined;
                    },
                    function (a) {
                        return a[i + 1];
                    }
                );

                minmax[i] = { min: _.min(line), max: _.max(line) };
            });
        });
    },
});

module.exports = ChartsZoomEnhance;
